import script from "./AppUploadQueuePanel.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppUploadQueuePanel.vue?vue&type=script&setup=true&lang=ts"

import "./AppUploadQueuePanel.vue?vue&type=style&index=0&id=01873dcc&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-01873dcc"]])

export default __exports__